import { ErrorTypes } from '../types/tracking/tracking'

export const CHECKOUT_CATEGORY_TRACKING_DATA = {
  category_id: 'CHECKOUT',
  category_path: 'CHECKOUT',
  page_id: 'MULTISTEP CHECKOUT SUMMARY',
}

const PAGE_TRACKING_DATA = {
  ...CHECKOUT_CATEGORY_TRACKING_DATA,
  checkout_version: 'checkout2',
} as const

export const DISCOUNT_TRACKING_EVENTS = {
  clickDiscountLink: {
    id: 'clickDiscountLink',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'apply_discount_link',
    },
  },
  addDiscountCode: {
    id: 'addDiscountCode',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'add_discount_code',
    },
  },
  removeDiscountCode: {
    id: 'removeDiscountCode',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'remove_discount_code',
    },
  },
  addVoucherClick: {
    id: 'addVoucherClick',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'add_voucher',
    },
  },
  removeVoucherClick: {
    id: 'removeVoucherClick',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'remove_voucher',
    },
  },
}

export const CHECKOUT_TRACKING_EVENTS = {
  pageView: {
    id: 'pageView',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'VIEW_CHECKOUT',
      checkout_step: 1,
    },
  },
  error: {
    id: 'error',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'ERROR_MESSAGE',
      error_area: 'checkout',
    },
  },
  myInfoEnter: {
    id: 'myInfoEnter',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_DETAILS_ENTER',
      checkout_step: 2,
    },
  },
  myInfoExit: {
    id: 'myInfoExit',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_DETAILS_EXIT',
      checkout_step: 2,
    },
  },
  billingEnter: {
    id: 'billingEnter',
    data: { ...PAGE_TRACKING_DATA, event_type: 'CHECKOUT_BILLING_ENTER', checkout_step: 3 },
  },
  billingExit: {
    id: 'billingExit',
    data: { ...PAGE_TRACKING_DATA, event_type: 'CHECKOUT_BILLING_EXIT', checkout_step: 3 },
  },
  deliverySpeedEnter: {
    id: 'deliverySpeedEnter',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_SHIPPING_ENTER',
      checkout_step: 4,
    },
  },
  deliverySpeedExit: {
    id: 'deliverySpeedExit',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_SHIPPING_EXIT',
      checkout_step: 4,
    },
  },
  paymentEnter: {
    id: 'paymentEnter',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_PAYMENT_ENTER',
      checkout_step: 5,
    },
  },
  completePurchase: {
    id: 'completePurchase',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_PURCHASE_CLICK',
    },
  },
  pageViewAllValidAndCollapsed: {
    id: 'pageViewAllValidAndCollapsed', // to be sent when all CO sections are validated on enter
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_MAIN_PAGE',
    },
  },
  backToSBClicked: {
    id: 'backToSBClicked',
    data: {
      ...PAGE_TRACKING_DATA,
      event_type: 'CHECKOUT_BACK_TO_SB_CLICKED',
      event_category: 'Checkout interactions',
      event_id: 'Back to SB clicked',
    },
  },
  ...DISCOUNT_TRACKING_EVENTS,
} as const

export const CHECKOUT_TRACKING_SECTIONS = {
  general: 'GENERAL' as CheckoutTrackingSections,
  myInformation: 'DETAILS' as CheckoutTrackingSections,
  deliveryLocation: 'ADDRESS' as CheckoutTrackingSections,
  deliverySpeed: 'SHIPPING' as CheckoutTrackingSections,
  payment: 'PAYMENT' as CheckoutTrackingSections,
  billing: 'BILLING' as CheckoutTrackingSections,
  completePurchase: 'PURCHASE' as CheckoutTrackingSections,
  login: 'LOGIN' as CheckoutTrackingSections,
} as const

export const CHECKOUT_TRACKING_ERROR_TYPES = {
  system: 'SYSTEM' as ErrorTypes,
  field: 'FIELD' as ErrorTypes,
}

export enum CheckoutTrackingSections {
  general = 'GENERAL',
  myInformation = 'DETAILS',
  deliveryLocation = 'ADDRESS',
  deliverySpeed = 'SHIPPING',
  payment = 'PAYMENT',
  billing = 'BILLING',
  completePurchase = 'PURCHASE',
  login = 'LOGIN',
}
